import OverviewCardHeader from "../Overview/OverviewCardHeader";
import OverviewEmptyState from "../Overview/OverviewEmptyState";
import { ShieldAlert } from "lucide-react";
import { Card, CardContent } from "../../ui/card";
import { RiskyAlertData } from "../interfaces/CommonInterfaces";

export default function OverviewRiskyAlerts({
  riskyAlerts,
  loading,
  fromdetails = false,
}: {
  riskyAlerts: RiskyAlertData[];
  loading: boolean;
  fromdetails?: boolean;
}) {
  const sortedRiskyAlerts = [...riskyAlerts].sort((a, b) => b.count - a.count);

  const getSeverityColor = (level: string) => {
    switch (level.toLowerCase()) {
      case "critical":
        return "bg-red-500";
      case "high":
        return "bg-orange-500";
      case "medium":
        return "bg-yellow-500";
      case "low":
        return "bg-blue-500";
      default:
        return "bg-gray-500";
    }
  };

  // Skeleton loader for each alert item
  const renderSkeletonItem = (key: number) => (
    <div
      key={key}
      className="flex items-center justify-between p-2 border rounded-md bg-background/50 animate-pulse"
    >
      <div className="flex items-center gap-2">
        <div className="w-3 h-3 bg-gray-300 rounded-full" />
        <div className="space-y-1">
          <div className="w-24 h-4 bg-gray-300 rounded" />
          <div className="w-40 h-3 bg-gray-300 rounded" />
        </div>
      </div>
      <div className="space-y-1 text-right">
        <div className="w-6 h-4 mx-auto bg-gray-300 rounded" />
        <div className="w-10 h-3 mx-auto bg-gray-300 rounded" />
      </div>
    </div>
  );

  return (
    <Card className="overview-card analytics-risk-card">
      <OverviewCardHeader
        fromdetails={fromdetails}
        title="Risky Alerts"
        description="Alert types ranked by frequency"
        icon={ShieldAlert}
      />
      <CardContent className="overview-card-content">
        <div className="analytics-risk-list space-y-3">
          {loading && [...Array(5)].map((_, idx) => renderSkeletonItem(idx))}

          {!loading &&
            riskyAlerts.length === 0 &&
            (fromdetails ? (
              <OverviewEmptyState
                icon={ShieldAlert}
                message="No risky alerts found."
              />
            ) : (
              <div className="py-8 text-sm text-center text-muted-foreground">
                No risky alerts found.
              </div>
            ))}

          {!loading &&
            riskyAlerts.length > 0 &&
            sortedRiskyAlerts.map((alert) => (
              <div
                key={alert.id}
                className="analytics-risk-row flex items-center justify-between p-2 border rounded-md bg-background/50 hover-elevate"
              >
                <div className="flex items-center gap-2">
                  <div
                    className={`w-3 h-3 rounded-full ${getSeverityColor(
                      alert.level,
                    )}`}
                  ></div>
                  <div>
                    <div className="text-sm font-medium">{alert.name}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium">{alert.count}</div>
                  <div className="text-xs text-muted-foreground">
                    {alert.percentage}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </CardContent>
    </Card>
  );
}
